<template>
  <div>
    <div class="search-form">
      <el-form
        inline
        :model="searchFormData"
        :rules="rules"
        ref="searchForm"
      >
        <el-form-item
          label="定时任务ID"
          prop="jobId"
        >
          <el-input v-model="searchFormData.jobId" />
        </el-form-item>
        <el-form-item
          label="任务名称"
          prop="jobName"
        >
          <el-input
            v-model="searchFormData.jobName"
            @keyup.native="filterInput(searchFormData, 'jobName')"
          />
        </el-form-item>
        <el-form-item label="任务路径">
          <el-input v-model="searchFormData.serviceName" />
        </el-form-item>
        <el-form-item label="Job类型">
          <el-select
            v-model="searchFormData.jobType"
            clearable
          >
            <el-option
              v-for="item in jobTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务状态">
          <el-select
            v-model="searchFormData.jobStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in jobStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="执行状态">
          <el-select
            v-model="searchFormData.resultStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in resultStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

    </div>
    <div class="flex-between">
      <div>
        <yh-button
          size="small"
          type="primary"
          @click="handleSearchClick"
        >查询</yh-button>
        <el-button
          size="small"
          @click="handleResetClick"
        >清空查询条件</el-button>
      </div>
      <div>
        <el-button
          size="small"
          @click="handleStopAllClick"
          :disabled="!selection || !selection.length"
          v-if="functionList.includes('322552643322613760')"
        >禁用任务</el-button>
        <el-button
          size="small"
          @click="visibleAdd = true"
          v-if="functionList.includes('322551814263902208')"
        >新增任务</el-button>
      </div>
    </div>
    <el-table
      ref="table"
      :data="tableData"
      border
      @selection-change="handleSelectionChange"
    >
      <template slot="empty">
        {{emptyText}}
      </template>
      <el-table-column
        type="selection"
        width="50"
      ></el-table-column>
      <el-table-column
        prop="jobId"
        label="定时任务ID"
        min-width="200"
      ></el-table-column>
      <el-table-column
        prop="jobName"
        label="任务名称"
        min-width="150"
      ></el-table-column>
      <el-table-column
        label="任务描述"
        min-width="300"
      >
        <template slot-scope="scope">{{scope.row.jobDesc | blankValue}}</template>
      </el-table-column>
      <el-table-column
        prop="serviceName"
        label="任务路径"
        min-width="200"
      ></el-table-column>
      <el-table-column
        prop="cron"
        label="CRON表达式"
        width="200"
      ></el-table-column>
      <el-table-column
        label="Job类型"
        min-width="150"
      >
        <template slot-scope="scope">
          {{scope.row.jobType | jobType}}
        </template>
      </el-table-column>
      <el-table-column
        prop="jobStatus"
        label="任务状态"
        min-width="150"
      >
        <template slot-scope="scope">
          {{jobStatusMap[scope.row.jobStatus]}}
        </template>
      </el-table-column>
      <el-table-column
        prop="jobStatus"
        label="执行状态"
        min-width="150"
      >
        <template slot-scope="scope">
          {{resultStatus[scope.row.resultStatus]}}
        </template>
      </el-table-column>
      <el-table-column
        label="上次执行结果"
        min-width="230"
      >
        <template slot-scope="scope">
          {{formatTime(scope.row.timeResult) + getResultText(scope.row.result)}}
        </template>
      </el-table-column>
      <el-table-column min-width="200">
        <template slot="header">
          <yh-caret
            @click="(v) => handleSortClick(v, 'createTime')"
            :sort="createTime"
          />
        </template>
        <template slot-scope="scope">
          {{scope.row.createTime | formatTime}}
        </template>
      </el-table-column>
      <el-table-column
        label="创建人ID"
        min-width="200"
      >
        <template slot-scope="scope">
          {{scope.row.createId | blankValue}}
        </template>
      </el-table-column>
      <el-table-column min-width="200">
        <template slot="header">
          <yh-caret
            @click="(v) => handleSortClick(v, 'updateTime')"
            :sort="updateTime"
          />
        </template>
        <template slot-scope="scope">
          {{scope.row.updateTime | formatTime}}
        </template>
      </el-table-column>
      <el-table-column
        label="更新人ID"
        min-width="200"
      >
        <template slot-scope="scope">
          {{scope.row.updateId | blankValue}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        width="200"
      >
        <template slot-scope="scope">
          <div class="feature-container">
            <span
              class="button--blue"
              @click="handleEditClick(scope.row)"
              v-if="functionList.includes('322553013969063936')"
            >编辑</span>
            <span
              class="button--blue"
              @click="handleRunClick(scope.row)"
              v-if="functionList.includes('322553144516775936')"
            >手动执行</span>
            <span
              class="button--blue"
              @click="gotoRunLog(scope.row)"
              v-if="functionList.includes('322553755190661120')"
            >查看日志</span>
            <span
              class="button--red"
              @click="handleDeleteClick(scope.row.jobId)"
              v-if="functionList.includes('322553266050928640')"
            >删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
    <!--新增弹框-->
    <yh-dialog
      title="新增任务"
      :visible.sync="visibleAdd"
    >
      <el-form
        ref="addForm"
        :model="addData"
        :rules="addRules"
        inline
      >
        <el-form-item
          label="任务名称"
          prop="jobName"
          required
        >
          <el-input
            v-model.trim="addData.jobName"
            @keyup.native="filterInput(addData, 'jobName')"
            placeholder="请输入任务名称，不超过50字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="任务描述"
          prop="jobDesc"
        >
          <el-input
            v-model="addData.jobDesc"
            placeholder="请输入任务描述，不超过200字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="任务路径"
          prop="serviceName"
          required
        >
          <el-input v-model="addData.serviceName"></el-input>
        </el-form-item>
        <el-form-item
          label="CRON表达式"
          prop="cron"
          required
        >
          <el-input v-model="addData.cron"></el-input>
        </el-form-item>
        <el-form-item
          label="Job类型"
          prop="jobType"
          placeholder="请选择"
          required
        >
          <el-select
            v-model="addData.jobType"
            clearable
          >
            <el-option
              v-for="item in jobTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Ktr文件"
          prop="ktrFileName"
          v-show="getFileVisibility(addData)"
        >
          <input
            @change="handleUploadChange($event, 'addData')"
            type="file"
            ref="addUpload"
            style="display:none"
          >
          <el-input
            readonly
            :value="addData.ktrFileName"
            @click.native="triggerUpload('addUpload')"
          >
            <el-button
              slot="append"
              icon="el-icon-upload"
            >点击上传</el-button>
          </el-input>
        </el-form-item>
        <el-form-item
          label="任务状态"
          prop="jobStatus"
          required
        >
          <el-select
            v-model="addData.jobStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in jobStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visibleAdd = false;">取消</el-button>
        <yh-button
          @click="handleAddClick()"
          type="primary"
        >新增任务</yh-button>
      </span>
    </yh-dialog>
    <!--修改弹框-->
    <yh-dialog
      title="编辑任务"
      :visible.sync="visibleEdit"
    >
      <el-form
        ref="editForm"
        :model="editData"
        :rules="editRules"
        inline
      >
        <el-form-item
          label="任务名称"
          prop="jobName"
          required
        >
          <el-input
            placeholder="请输入任务名称，不超过50字"
            v-model="editData.jobName"
            @keyup.native="filterInput(editData, 'jobName')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="任务描述"
          prop="jobDesc"
        >
          <el-input
            placeholder="请输入任务描述，不超过200字"
            v-model="editData.jobDesc"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="任务路径"
          prop="serviceName"
          required
        >
          <el-input v-model="editData.serviceName"></el-input>
        </el-form-item>
        <el-form-item
          label="CRON表达式"
          prop="cron"
          required
        >
          <el-input v-model="editData.cron"></el-input>
        </el-form-item>
        <el-form-item
          label="Job类型"
          prop="jobType"
          required
        >
          <el-select
            v-model="editData.jobType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in jobTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Ktr文件"
          prop="ktrFileName"
          v-show="getFileVisibility(editData)"
        >
          <input
            @change="handleUploadChange($event, 'editData')"
            type="file"
            ref="editUpload"
            style="display:none"
          >
          <el-input
            readonly
            :value="editData.ktrFileName"
            @click.native="triggerUpload('editUpload')"
          >
            <el-button
              slot="append"
              icon="el-icon-upload"
            >点击上传</el-button>
          </el-input>
        </el-form-item>
        <el-form-item
          label="任务状态"
          prop="jobStatus"
          required
        >
          <el-select
            v-model="editData.jobStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in jobStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visibleEdit = false;">取消</el-button>
        <el-button
          type="primary"
          @click="handleUpdateClick"
        >保存</el-button>
      </span>
    </yh-dialog>
  </div>
</template>

<script>
import {
  pageCount, getFunctionList, getPagingData, addNav,
} from '@/mixins';
import api from './api';

export default {
  name: 'JobManagement',
  mixins: [pageCount, getFunctionList, getPagingData, api, addNav],
  data() {
    const { userId } = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      userId,
      emptyText: this.$LS.empty,
      rules: {
        jobName: [
          {
            validator: (rule, value, callback) => {
              if (value.length > 50) {
                callback(this.$MSG.M0047);
              } else {
                callback();
              }
            },
          },
        ],
        jobId: [
          {
            validator: (rule, value, cb) => {
              if (/^\d+$/g.test(value) || !value) {
                cb();
              } else {
                cb(this.$MSG.M0213);
              }
            },
          },
        ],
      },
      dataRules: {
        jobName: [
          { required: true, message: ' ' },
          {
            validator: (rule, value, callback) => {
              if (value.length > 50) {
                callback(this.$MSG.M0047);
              } else {
                callback();
              }
            },
          },
        ],
        jobDesc: [
          {
            validator: (rule, value, callback) => {
              if (value.length > 200) {
                callback(this.$MSG.M0048);
              } else {
                callback();
              }
            },
          },
        ],
        serviceName: [
          { required: true, message: ' ' },
          {
            validator: (rule, value, cb) => {
              if (value.length > 200) {
                cb(this.$MSG.M0123);
              } else {
                cb();
              }
            },
          },
        ],
        jobStatus: [{ required: true, message: ' ' }],
        jobType: [{ required: true, message: ' ' }],
        cron: [{ message: ' ', required: true }],
      },
      selection: [],
      jobStatusMap: {
        0: '重复',
        1: '手动',
        2: '禁用',
      },
      functionList: [],
      title: '',
      modelTitle: '', // 模板标题（查询条件）
      currentPage: 1, // 当前页
      pageSize: 10, // 每页显示记录数
      sumCount: 0, // 总记录数
      dictTypeCode: [], // 产品类型集合（查询条件）
      nowIndexes: [],
      selected: '', // 下拉框选中
      checkedId: '', // 选中的id
      pickOrBan: '', // 启动中或停止中
      flag: 'flag', // 重跑定时任务的flag
      resultStatus: {
        0: '已暂停',
        1: '执行中',
      },
      resultStatusList: [
        {
          label: '已暂停',
          value: '0',
        },
        {
          label: '执行中',
          value: '1',
        },
      ],
      jobStatusList: [
        {
          label: '重复',
          value: '0',
        },
        {
          label: '手动',
          value: '1',
        },
        {
          label: '禁用',
          value: '2',
        },
      ],
      jobTypeList: [
        {
          label: '非Kettle任务',
          value: '1',
        },
        {
          label: 'Kettle任务',
          value: '0',
        },
      ],
      visibleAdd: false,
      visibleEdit: false,
      addData: {
        serviceName: '',
        jobName: '',
        jobType: '',
        jobDesc: '',
        jobStatus: '',
        cron: '',
        ktr: '',
        ktrFileName: '',
        createId: '',
        updateId: '',
      },
      baseData: {
        jobId: '',
        serviceName: '',
        jobName: '',
        jobType: '',
        jobDesc: '',
        jobStatus: '',
        cron: '',
        ktr: '',
        ktrFileName: '',
        updateId: '',
        createId: '',
      },
      editData: {
        jobId: '',
        serviceName: '',
        jobName: '',
        jobType: '',
        jobDesc: '',
        jobStatus: '',
        cron: '',
        ktr: '',
        ktrFileName: '',
        updateId: '',
        createId: '',
      },
      tableData: [],
      searchFormData: {
        jobId: '',
        serviceName: '',
        jobName: '',
        jobType: '',
        jobStatus: '',
        resultStatus: '',
      },
      searchParam: {
        jobId: '',
        serviceName: '',
        jobName: '',
        jobType: '',
        jobStatus: '',
        resultStatus: '',
        sort: '',
        order: '',
      },
      createTime: {
        label: '创建时间',
        order: 0,
      },
      updateTime: {
        label: '更新时间',
        order: 0,
      },
    };
  },
  computed: {
    addRules() {
      return {
        ...this.dataRules,
        ktrFileName: [{ required: this.addData.jobType === '0', message: ' ' }],
      };
    },
    editRules() {
      return {
        ...this.dataRules,
        ktrFileName: [{ required: this.editData.jobType === '0', message: ' ' }],
      };
    },
  },
  watch: {
    visibleAdd(v) {
      if (!v) {
        Object.keys(this.addData).forEach((item) => {
          this.addData[item] = '';
        });
      }
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate();
      }
    },
    currentPage: {
      immediate: true,
      handler() {
        this.selectJobDetailList();
      },
    },
  },
  filters: {
    jobType(v) {
      const job = {
        1: '非Kettle任务',
        0: 'Kettle任务',
      };
      return job[v];
    },
  },
  methods: {
    handleEditClick(row) {
      this.editData = {
        ...this.baseData,
        ...row,
      };
      this.visibleEdit = true;
    },
    gotoRunLog(data) {
      this.addNav({
        path: '/runLogMain',
        name: 'Job运行日志',
        query: {
          id: data.jobId,
        },
      });
    },
    filterInput(obj, key) {
      // eslint-disable-next-line no-param-reassign
      obj[key] = obj[key].replace(/[^\w\u4E00-\u9FA5]/g, '');
    },
    handleRunClick(data) {
      this.$_yh_confirm('确定立即执行', '手动执行').then(() => {
        this.manualStart(data);
      });
    },
    manualStart(data) {
      return this.$_post(this.$API.jobHandStart, {
        data: {
          jobId: data.jobId,
          cron: data.cron,
          jobStatus: data.jobStatus,
          createId: data.createId,
          jobName: data.jobName,
          resultStatus: data.resultStatus,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0055);
          this.selectJobDetailList();
        } else if (res.errorCode === this.$CODE.jobRunning) {
          this.$message.warning(this.$MSG.M0051);
        } else {
          this.$message.warning(this.$MSG.M0054);
        }
      });
    },
    handleSortClick(v, name) {
      const swapMap = {
        createTime: 'updateTime',
        updateTime: 'createTime',
      };
      const map = {
        ascending: 'asc',
        descending: 'desc',
      };
      // 重置其他排序
      this[swapMap[name]].order = 0;
      this.searchParam.sort = name;
      this.searchParam.order = map[v];
      if (!v) {
        this.searchFormData.sort = '';
        this.searchFormData.order = '';
      }
      if (this.currentPage === 1) {
        this.selectJobDetailList();
      } else {
        this.currentPage = 1;
      }
    },
    getFileVisibility(data) {
      return data.jobType === '0';
    },
    getResultText(v) {
      const resultMap = {
        0: '成功',
        1: '失败',
      };
      const text = resultMap[v];
      return text ? `(${text})` : '';
    },
    handleSelectionChange(v) {
      this.selection = v;
    },
    triggerUpload(name) {
      this.$refs[name].click();
    },
    handleUploadChange(e, name) {
      const uploaders = {
        editData: 'editUpload',
        addData: 'addUpload',
      };
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (re) => {
        this[name].ktr = re.target.result;
        this.$refs[uploaders[name]].value = '';
      };
      reader.readAsDataURL(file);
      this[name].ktrFileName = file.name;
    },
    handleResetClick() {
      Object.keys(this.searchFormData).forEach((key) => {
        this.searchFormData[key] = '';
      });
      this.createTime.order = 0;
      this.updateTime.order = 0;
      this.searchFormData.sort = '';
      this.searchFormData.order = '';
    },
    handleSearchClick() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.createTime.order = 0;
          this.updateTime.order = 0;
          this.searchFormData.sort = '';
          this.searchFormData.order = '';
          this.searchParam = {
            ...this.searchParam,
            ...this.searchFormData,
          };
          if (this.currentPage === 1) {
            this.selectJobDetailList();
          } else {
            this.currentPage = 1;
          }
        }
      });
    },
    selectJobDetailList() {
      this.getPagingData(this.$API.jobList);
    },
    handleAddClick() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let { ktrFileName } = this.addData;
          if (this.editData.jobType === '1') {
            // 如果是非 kettle 类型，不必传 ktrFilename
            ktrFileName = '';
          }
          const params = {
            data: {
              ...this.addData,
              createId: this.userId,
              updateId: this.userId,
              ktrFileName,
            },
          };
          this.save(params).then((res) => {
            if (res.errorCode === this.$CODE.success) {
              this.selectJobDetailList();
              this.visibleAdd = false;
              this.$message.success(this.$MSG.M0049);
            } else if (res.errorCode === this.$CODE.existJobName) {
              this.$message.warning(this.$MSG.M0068);
            } else if (res.errorCode === this.$CODE.errorCron) {
              this.$message.warning(res.errorMsg);
            } else {
              this.$message.error(this.$MSG.M0050);
            }
          });
        }
      });
    },
    handleUpdateClick() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          let { ktrFileName } = this.editData;
          if (this.editData.jobType === '1') {
            ktrFileName = '';
          }
          const params = {
            data: {
              ...this.editData,
              updateId: this.userId,
              ktrFileName,
            },
          };
          this.updateJob(params);
        }
      });
    },
    updateJob(params) {
      return this.update(params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.visibleEdit = false;
          this.selectJobDetailList();
          this.$message.success(this.$MSG.M0111);
          this.visibleEdit = false;
        } else if (res.errorCode === this.$CODE.jobRunning) {
          this.$message.warning(this.$MSG.M0051);
        } else if (res.errorCode === this.$CODE.existJobName) {
          this.$message.warning(this.$MSG.M0068);
        } else if (res.errorCode === this.$CODE.errorCron) {
          this.$message.warning(res.errorMsg);
        } else {
          this.$message.error(this.$MSG.M0112);
        }
      });
    },
    handleStopAllClick() {
      const n = this.selection.length;
      this.$_yh_confirm(
        `已选择${n}条定时任务，运行中的任务将无法禁用，确定禁用`,
        '禁用任务',
      ).then(() => {
        this.stopSelectedJob();
      });
    },
    stopSelectedJob() {
      const jobId = this.selection.map(item => item.jobId);
      const jobStatus = this.selection.map(item => item.jobStatus);
      const resultStatus = this.selection.map(item => item.resultStatus);

      this.$_post(this.$API.stopById, {
        data: {
          jobId,
          jobStatus,
          resultStatus,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0060(res.sumCount));
          this.selectJobDetailList();
        } else {
          this.$message.error(this.$MSG.M0030);
        }
      });
    },
    handleDeleteClick(jobId) {
      const params = {
        data: {
          jobId,
        },
      };
      this.$_yh_confirm('仅能删除禁用的任务，确认删除', '删除任务').then(() => {
        this.delete(params).then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.$message.success(this.$MSG.M0056);
            this.selectJobDetailList();
          } else {
            this.$message.error(this.$MSG.M0057);
          }
        });
      });
    },
  },
};
</script>
